/**
 * CR204: Header Block
 * CR285: Added debug logging + fixed config mapping to ensure titleText from layout is used.
 * 
 * Renders the page header based on layout configuration.
 * Wraps PublicLayoutHeader for consistent rendering.
 */

import { useEffect } from "react";
import type { BlockProps } from "./types";
import type { HeaderBlockConfig } from "@/lib/layout-studio/types";
import { PublicLayoutHeader } from "@/components/public/PublicLayoutHeader";
import { DEFAULT_HEADER_CONFIG } from "@/lib/layout-studio/types";

export function HeaderBlock({ config, context }: BlockProps<HeaderBlockConfig>) {
  // CR285: Debug logging to trace config source
  useEffect(() => {
    console.log("[HeaderBlock] CR285 Config received from LayoutRenderer:", {
      configFromBlock: config,
      titleText: config?.titleText,
      subtitleText: config?.subtitleText,
    });
  }, [config]);
  
  // CR285: Merge defaults with block config - block config takes precedence
  const mergedConfig: HeaderBlockConfig = {
    ...DEFAULT_HEADER_CONFIG,
    ...config,
  };
  
  // CR285: Debug - log what we're passing to PublicLayoutHeader
  useEffect(() => {
    console.log("[HeaderBlock] CR285 Merged config being passed to PublicLayoutHeader:", {
      titleText: mergedConfig.titleText,
      subtitleText: mergedConfig.subtitleText,
      showTitle: mergedConfig.showTitle,
      showSubtitle: mergedConfig.showSubtitle,
    });
  }, [mergedConfig]);
  
  return (
    <PublicLayoutHeader 
      config={mergedConfig} 
      loading={context.loading} 
    />
  );
}
